module.exports = __webpack_public_path__ + "img/Frame.ab0ab2ad.png";